// extracted by mini-css-extract-plugin
export var dateLabel = "_4i-0";
export var dateLabelError = "_4i-1";
export var fullWidth = "_4i-2";
export var smaller = "_4i-3";